import { Injectable } from '@angular/core';
import { IProjectScope } from '@common/interfaces/projectScope';
import { QueryEntity } from '@datorama/akita';
import { switchMap } from 'rxjs/operators';
import { ProjectQuery } from '../project/project.query';
import { ProjectScopeState, ProjectScopeStore } from './projectScope.store';
import { RoleNames } from '@common/interfaces/permissions';

@Injectable({
  providedIn: 'root'
})
export class ProjectScopeQuery extends QueryEntity<ProjectScopeState> {
  all$ = this.selectAll();

  constructor(protected store: ProjectScopeStore, private projectQuery: ProjectQuery) {
    super(store);
  }

  active$ = this.projectQuery.selectActiveId().pipe(
    switchMap((id) => {
      return this.selectEntity((item) => item.projectId === id);
    })
  );

  getByProjectId(projectId: string): IProjectScope {
    return this.getAll().find((c) => c.projectId === projectId);
  }

  getRoleNamesByProjectAndUser(projectId: string, userId: string): RoleNames[] {
    const projectScope = this.getByProjectId(projectId);
    if (!projectScope) {
      return [];
    }
    const currentUserRole = projectScope?.users?.filter((user) => user.id === '#everyone#' || user.id === userId);
    return currentUserRole.flatMap((r) => r.roles);
  }
}
